import React, {PureComponent, ReactNode} from "react"
import gql from "graphql-tag"
import {Query} from "react-apollo"

import {Query as QueryComponent, hasMorePagination} from "@irati/utils/services/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import RewardOrder from "./fragments/RewardOrder"

const query = gql`
  query RewardRedemptions($tenantId: String!, $userId: String!, $limit: Int, $offset: Int)  {
    rewardRedemptions(tenantId: $tenantId, userId: $userId, limit: $limit, offset: $offset) {
      hasMore
      limit
      offset
      count
      results {
        id
        tenantId
        createdAt
        stockId
        stock {
          status
          usage
          code
          pin
          type
          expiry
        }
        recipient {
          uuid
          firstname
          lastname
        }
        rewardOrder {
          ...RewardOrder
        }
        custom
        recipientUserId
      }
    }
  }

  ${RewardOrder}
`

interface AccountRewardsVariables {
  limit?: number,
  offset?: number,
  tenantId: string,
  userId: string
}

export interface AccountRewardsData {
  data: {
    rewardRedemptions: RewardRedemptionList
  }
}

interface Props {
  variables: AccountRewardsVariables,
  children(state: ApolloState): ReactNode,
  useError?: boolean,
  useLoader?: boolean
}

export interface QueryData {
  rewardRedemptions: RewardRedemptionList
}

class TypedQuery extends Query<AccountRewardsData, AccountRewardsVariables> {}

export default class AccountRewardsQuery extends PureComponent<Props> {
  static defaultProps = {
    useError: false,
    useLoader: false,
    query
  }

  render() {
    const {variables, children} = this.props
    return <QueryComponent
      {...this.props}
      query={query}
      QueryComponent={TypedQuery}
      notifyOnNetworkStatusChange
      useError={false}
      useLoader={false}>
      {(apolloState: ApolloState) => {
        const fetchMore = (vars: AccountRewardsVariables) => {
          return hasMorePagination(
            {
              query,
              variables: vars
            },
            apolloState
          )
        }
        const refetch = (vars = variables) => {
          apolloState.refetch(vars)
        }
        return children({...apolloState, fetchMore, refetch})
      }}
    </QueryComponent>
  }
}
